import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import setDirectLink from 'utils/setDirectLink';
import { DIRECT_LINK } from '../Shared/constants';

interface Properties {
    children: React.ReactNode;
}

function Authenticated({ children }: Properties): React.ReactElement {
    const location = useLocation();
    const history = useHistory();

    const returnTo = (): string => {
        let locationToReturn = `${location.pathname}${window.location.search}`;

        // If we receive an invitation link, we do not want to store it as a returnTo
        // entry in state for the return of the redirect from authentication so send them
        // to the home page instead.
        if (location.search.startsWith('?invitation')) locationToReturn = '/';

        return sessionStorage.getItem(DIRECT_LINK) || locationToReturn;
    };

    const onRedirecting = (): JSX.Element => <></>;

    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    React.useEffect(() => {
        setDirectLink();
        if (isLoading || isAuthenticated) {
            const returnToLocation: string = returnTo();

            // If the current location we land on is the basic redirectUri and not
            // where we wanted to go, then route us to the right location.  This
            // is the primary way of routing when the user is already authenticated.
            // For a user who is not authenticated, see the details in the SubscriptionWrapper
            // surrounding the AppState and redirect options.

            if (window.location.href === `${BASE_PATH}/` && !window.location.href.endsWith(returnToLocation)) {
                history.push(returnToLocation);
            }
        } else {
            (async (): Promise<void> => {
                const opts = {
                    appState: { returnTo: returnTo() },
                };
                await loginWithRedirect(opts);
            })();
        }
    }, [isLoading, isAuthenticated, loginWithRedirect, returnTo]);

    return isAuthenticated ? <>{children}</> : onRedirecting();
}

export default Authenticated;
